// extracted by mini-css-extract-plugin
export var cancelButton = "_om-5";
export var content = "_om-3";
export var createButton = "_om-6";
export var drawerContainer = "_om-0";
export var footer = "_om-2";
export var header = "_om-1";
export var orderFormColumn = "_om-4";